import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAnimeGeneratorConfig } from '@/data/landingConfig/landingAnimeGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AnimeGenerator } from './schemaObject';

interface Props {}
const AnimeGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AnimeGenerator} />
			<LandingTemplate
				data={landingAnimeGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAnimeGenerator()}
			/>
		</>
	);
};

export default AnimeGenerator;
